import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Branding */}
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/851b34e1-8f86-4e8d-b654-afa9579ed5f4.png"
              alt="Clinic Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Providing compassionate, comprehensive healthcare to the community with excellence and dedication.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-full hover:border-blue-500 hover:text-blue-500 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-600 rounded-full hover:border-blue-500 hover:text-blue-500 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            <p className="text-xs text-gray-500 mt-4">
              CPSO Registration: #123456
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/new-patients" className="text-gray-400 hover:text-white transition-colors duration-200">
                  New Patients
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-400">General Health Checkups</li>
              <li className="text-gray-400">Chronic Disease Management</li>
              <li className="text-gray-400">Vaccinations</li>
              <li className="text-gray-400">Preventive Care</li>
              <li className="text-gray-400">Minor Procedures</li>
              <li className="text-gray-400">Specialist Referrals</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-blue-400"></i>
                </div>
                <span className="text-gray-400">
                  123 Medical Centre Drive<br/>
                  Toronto, ON M5H 2N2
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-fill text-blue-400"></i>
                </div>
                <a href="tel:+14165551234" className="text-gray-400 hover:text-white transition-colors duration-200">
                  (416) 555-1234
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-fill text-blue-400"></i>
                </div>
                <a href="mailto:info@doctorclinic.ca" className="text-gray-400 hover:text-white transition-colors duration-200">
                  info@doctorclinic.ca
                </a>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-gray-700">
              <h4 className="font-semibold mb-3">Office Hours</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <div className="flex justify-between">
                  <span>Mon - Fri</span>
                  <span>9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span>10:00 AM - 2:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Medical Clinic. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
